module.exports = __webpack_public_path__ + "img/Celebrate2-mirror.9c50528a.png";